// extracted by mini-css-extract-plugin
module.exports = {"card":"Pec_card__ZWk8-"};